var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEntityContext } from '../EntityContext';
export const EntityPicker = (_a) => {
    var { value, disabled, error, helperText, filter = () => true, onChange, fullWidth, disableClearable } = _a, props = __rest(_a, ["value", "disabled", "error", "helperText", "filter", "onChange", "fullWidth", "disableClearable"]);
    const { entities } = useEntityContext();
    const selected = entities === null || entities === void 0 ? void 0 : entities.find(entity => {
        return value && [entity.id, entity.name, entity.tableName].includes(value);
    });
    return (React.createElement(Autocomplete, { disableClearable: disableClearable, fullWidth: fullWidth, forcePopupIcon: true, disabled: disabled, value: selected || null, options: (entities || []).filter(filter), getOptionLabel: option => option.displayName || option.name, onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined), renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', placeholder: 'Select an Entity', error: error, helperText: helperText }, props, { InputProps: Object.assign(Object.assign({}, params.InputProps), props.InputProps) }))) }));
};
export default EntityPicker;
//# sourceMappingURL=EntityPicker.js.map